import React from "react";
import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import AssignedAgentDisplay from "@/modules/common/components/assigned-agent-display";
import { UserV2 } from "@/modules/user/dtos/index.v2";
import { capitalizeFirstLetter } from "@/modules/common/utils";
import { formatDateReadable } from "@/modules/leads/utils/index";
interface RatingCommentProps {
  comment: string;
  createdAt: string | Date;
  user?: UserV2 | null;
}

const RatingComment: React.FC<RatingCommentProps> = ({
  comment,
  createdAt,
  user,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        position: "relative",
      }}
    >
      {/* Vertical Line */}
      <Box
        sx={{
          left: 0,
          top: 0,
          bottom: 0,
          width: 4,
          borderRadius: nawyTheme.nawy.radius.full,
          backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: nawyTheme.nawy.spacing.xxs,
          flex: 1,
          marginLeft: nawyTheme.nawy.spacing.sm,
          overflow: "visible",
          paddingTop: nawyTheme.nawy.spacing.xs,
          paddingBottom: nawyTheme.nawy.spacing.xs,
        }}
      >
        {/* Comment Text */}
        <Typography
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
            color: nawyTheme.nawy.colors.semantic.text.primary,
          }}
        >
          {capitalizeFirstLetter(comment)}
        </Typography>

        {/* Timestamp */}
        <Typography
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.xs.regular,
            color: nawyTheme.nawy.colors.semantic.text.secondary,
          }}
        >
          {formatDateReadable(createdAt as string)}
        </Typography>

        {/* User Info */}
        <AssignedAgentDisplay
          user={user as UserV2}
          withRank={true}
          agentNameSx={{
            ...nawyTheme.nawy.typography.english.variants.body.sm.regular,
            color: nawyTheme.nawy.colors.semantic.text.primary,
          }}
          isMappingRank={true}
        />
      </Box>
    </Box>
  );
};

export default RatingComment;
